<template>
  <div>
    <el-form
      role="form"
      class=""
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <div>
        <p class="fsize14 font-semibold text-4f4f4f mb-0">
          Add Attribute Value
        </p>
        <!-- <el-input
        placeholder="Enter or Type Attributes value..."
        v-model="attributeVal"
        @change="addAttributeValuePrimary"
        class="rounded-xl mt-2"
      /> -->
        <el-form-item class="" prop="attributeVal">
          <el-input
            placeholder="Enter or Type Attributes value..."
            v-model="ruleForm.attributeVal"
            class="rounded-xl mt-2"
          />
        </el-form-item>
        <!-- <el-select
        filterable
        allow-create
        default-first-option
        v-model="attributeVal"
        @change="addAttributeValuePrimary"
        placeholder="Select"
        class="w-full mt-1"
      >
        <el-option
          v-for="item in singleAttrinutesPrime.attributeValueId"
          :key="item.attributeValue"
          :label="item.attributeValue"
          :value="item.attributeValue"
        >
        </el-option>
      </el-select> -->
      </div>

      <div class="mt-6">
        <p class="fsize14 font-semibold text-4f4f4f mb-0">Image</p>
        <!-- :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList" -->
        <el-upload
          v-if="datavalue.length == 0"
          class="upload-demo mt-1 category-uploader"
          multiple
          action="#"
          drag
          :before-upload="multipleimages"
          accept="image/*"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <!-- <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div> -->
        </el-upload>
        <div class="mt-6 grid grid-cols-4 gap-2">
          <!-- <div
          v-for="(item, index) in renderedmultipleImage"
          class="relative"
          :key="item"
        > -->
          <!-- <transition-group name="image-transition" tag="div" class="image-list"> -->
          <!-- @dragend="handleDragEnd"
            @dragenter="handleDragEnter(index)"
            @dragleave="handleDragLeave" 
            :class="{
              dragging: index === draggedIndex,
              'shift-left': index > draggedIndex && index <= shiftedIndex,
              'shift-right': index < draggedIndex && index >= shiftedIndex,
            }"-->
          <!-- <div class="image-list"> -->
          <div
            v-for="(image, index) in renderedmultipleImage"
            :draggable="true"
            @dragstart="handleDragStart(index, $event)"
            @dragover="handleDragOver(index, $event)"
            @drop="handleDrop(index)"
            class="relative draggable-item"
            :key="`${image} + ${index}`"
          >
            <img
              :src="image"
              class="rounded-4px object-cover w-full imgpre h-75px"
            />

            <div
              class="absolute top-0 xiconset right-0 bg-white rounded-full p-1"
            >
              <feather-icon
                icon="XIcon"
                svgClasses="w-3 h-3"
                class="cursor-pointer flex"
                @click="
                  () => {
                    datavalue.splice(index, 1);
                    renderedmultipleImage.splice(index, 1);
                  }
                "
              />
            </div>
          </div>
          <!-- </div> -->
          <el-upload
            v-if="datavalue.length < 10 && datavalue.length > 0"
            class="upload-demo mt-1 vi-up custuploadht"
            multiple
            action="#"
            drag
            :before-upload="multipleimages"
            accept="image/*"
          >
            <i class="el-icon-upload"></i>
          </el-upload>
        </div>
      </div>
      <div class="mt-6 flex justify-center">
        <vs-button
          @click="handleSubmit('ruleForm')"
          type="primary"
          class="rounded-full fsize14 bg-primary text-white px-16 font-semibold cursor-pointer py-4"
        >
          Save
        </vs-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    openAttributeVal: {
      Type: Boolean,
    },
  },
  data() {
    return {
      isDragging: false,
      activeNames: "1",
      AddColor: false,
      value1: [],
      value2: [],
      Attribute2: [],
      attributeVal: "",
      datavalue: [],
      counter: 1,
      attributeValueId: {},
      renderedmultipleImage: [],
      attributessizeOptions: [
        {
          value: "XL",
          label: "XL",
        },
        {
          value: "LG",
          label: "LG",
        },
      ],
      draggedIndex: null,
      // shiftedIndex: null,

      ruleForm: {
        attributeVal: "",
      },
      rules: {
        attributeVal: [
          {
            required: true,
            message: "Please Enter Attribute Value",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleSubmit(formName) {
      this.ruleForm.attributeVal = this.ruleForm.attributeVal.trim();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveAttributeVal();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.ruleForm.attributeVal = "";
      this.datavalue = [];
      this.counter = 1;
      this.renderedmultipleImage = [];
    },
    handleDragStart(index, event) {
      this.draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", index);
    },
    handleDragOver(index, event) {
      event.preventDefault();
      // if (index !== this.draggedIndex) {
      //   this.shiftedIndex = index;
      // }
    },
    handleDrop(index) {
      // if (index !== this.draggedIndex) {
      const draggedImage = this.renderedmultipleImage[this.draggedIndex];
      this.renderedmultipleImage.splice(this.draggedIndex, 1);
      this.renderedmultipleImage.splice(index, 0, draggedImage);

      const draggedImageData = this.datavalue[this.draggedIndex];
      this.datavalue.splice(this.draggedIndex, 1);
      this.datavalue.splice(index, 0, draggedImageData);
      // this.draggedIndex = index;
      // }
      // this.shiftedIndex = null;
    },
    handleDragEnd() {
      this.draggedIndex = null;
      // this.shiftedIndex = null;
    },
    handleDragEnter(index) {
      // if (index !== this.draggedIndex) {
      //   this.shiftedIndex = index;
      // }
    },
    handleDragLeave() {
      // this.shiftedIndex = null;
    },

    handleRemove() {},
    handlePreview() {},
    fileList() {},

    closePopup() {
      // this.$store.state.EcomAttributes.attributePopupOpen = true;
      // this.$store.state.EcomAttributes.attributeValPopup = false;
      this.$store.commit("EcomAttributes/SET_ATTRIBUTE_VAL_POPUP", false);
      this.$store.commit("EcomAttributes/SET_ATTRIBUTE_POPUP_OPEN", true);
    },
    async addAttributeValuePrimary() {
      let payload = {
        attributeValue: this.ruleForm.attributeVal,
        attributeName: this.onClickProduct.attributesId[0].name,
      };
      console.log(payload);
      this.attributeValueId = await this.$store.dispatch(
        "EcomAttributes/addAttributesValue",
        payload
      );
      await this.$store.dispatch("EcomProduct/getAllProduct");
    },
    async multipleimages(file) {
      // console.log(file.target.files,"khk");
      console.log(file);
      // console.log(this.datavalue);
      if (this.datavalue.length < 10) {
        this.datavalue.push(file);
      } else {
        // this.datavalue.shift(file);
        return await this.$swal({
          title: `Only 10 Images are Allowed!`,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#cd3197",
        });
      }
      console.log(this.datavalue.length);
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < 10) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        } else {
          // this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };

      reader.readAsDataURL(rawFile);
    },
    async readFile(file) {
      let self = this;
      let result = await new Promise((resolve) => {
        if (file) {
          let reader = new FileReader();
          let fileName = file.name.split(".");
          reader.onload = async function (event) {
            var renamedFile = new File(
              [event.target.result],
              `${self.counter}.${fileName[fileName.length - 1]}`,
              { type: file.type }
            );
            // renameFiles.push(renamedFile);
            // payload.append("productImage", renamedFile);
            console.log(self.counter);
            self.counter++;
            resolve(renamedFile);
            console.log(renamedFile);
          };
          reader.readAsArrayBuffer(file);
        }
      });
      return result;
    },
    async saveAttributeVal() {
      if (this.datavalue && this.datavalue.length <= 0) {
        return await this.$swal({
          title: `Please upload Images!`,
          type: "error",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#cd3197",
        });
      }

      const payload = new FormData();
      await this.addAttributeValuePrimary();
      // console.log(this.attributeValueId);
      payload.append("valueName", this.ruleForm.attributeVal);
      payload.append("productId", this.onClickProduct._id);
      // payload.append("attributeValueId", this.attributeValueId._id);
      // let counter = 1;
      // let renameFiles = [];
      for (let i in this.datavalue) {
        // payload.append("productImage", this.datavalue[i]);
        // console.log(this.datavalue[i].name);
        let file = this.datavalue[i];
        let data = await this.readFile(file);
        console.log(data);
        payload.append("productImage", data);
        // console.log(this.datavalue[i].name);
      }
      console.log(this.datavalue);
      await this.$store.dispatch("EcomProduct/productImage", payload);
      await this.$store.dispatch("EcomProduct/getAllProduct");
      for (let i = 0; i < this.productDetails.length; i++) {
        if (this.onClickProduct._id == this.productDetails[i]._id) {
          this.$store.commit(
            "EcomAttributes/SET_ON_CLICK_PRODUCT",
            this.productDetails[i]
          );
          // this.$store.state.EcomAttributes.onClickProduct =
          //   this.productDetails[i];
        }
      }
      this.resetForm("ruleForm");
      this.$emit("closePopup");
    },
    // async loadData() {
    //   let payload1 = {
    //     attributeName: this.onClickProduct.attributesId[0]._id,
    //   };
    //   await this.$store.dispatch(
    //     "EcomAttributes/getSingleAttributesPrim",
    //     payload1
    //   );
    // },
  },
  // mounted() {
  //   console.log(this.onClickProduct);
  // },
  computed: {
    ...mapState("EcomAttributes", [
      "EcomAttrinutes",
      "singleAttrinutesPrime",
      "singleAttrinutesSec",
      "onClickProduct",
    ]),
    ...mapState("EcomProduct", ["productDetails"]),
  },
};
</script>

<style>
.draggable-item {
  margin-bottom: 10px;
  cursor: move;
  transition: transform 0.3s ease-in-out;
}
.custuploadht .el-upload-dragger {
  height: 75px;
}
.custuploadht .el-upload-dragger .el-icon-upload {
  line-height: 0px !important;
  font-size: 50px !important;
}
/* .image-transition-enter-active,
.image-transition-leave-active {
  transition: all 0.3s ease-in-out;
} */

/* .image-transition-enter,
.image-transition-leave-to {
  opacity: 0;
  transform: translateY(20px);
} */

/* .image-list {
  display: flex;
  flex-direction: row;
} */

/* .dragging-over {
  animation-name: drag-over-animation;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-direction: alternate;
} */

/* .dragging {
  opacity: 0.5;
}

.shift-left {
  transform: translateX(-50px);
}

.shift-right {
  transform: translateX(50px);
} */
/* 
@keyframes drag-over-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
} */
</style>
